import { ReactElement } from 'react';
import { Route } from 'react-router-dom';

import { Dashboard } from 'modules/dashboard/screens/Dashboard';

import { StakeForm } from './components/StakeUnstake/StakeForm';
import { UnstakeForm } from './components/StakeUnstake/UnstakeForm';
import { dashboardRoutesConfig } from './dashboardRoutesConfig';

export function getDashboardRoutes(): ReactElement {
  return (
    <>
      <Route
        element={<Dashboard />}
        path={dashboardRoutesConfig.dashboard.path}
      >
        <Route
          index
          element={<StakeForm />}
          path={dashboardRoutesConfig.dashboard.generatePath()}
        />

        <Route
          index
          element={<StakeForm />}
          path={dashboardRoutesConfig.staking.generatePath()}
        />

        <Route
          element={<UnstakeForm />}
          path={dashboardRoutesConfig.unstaking.generatePath()}
        />
      </Route>
    </>
  );
}
